<template>
  <table>
    <slot />
  </table>
</template>

<style lang="postcss" scoped>
table {
  @apply border-collapse w-full;
}

:deep(th),
:deep(td) {
  @apply border border-grey p-2;
}

:deep(thead th) {
  @apply bg-primary text-white font-kyiv font-500 border-transparent px-8;

  &:first-child {
    @apply rounded-tl-xl;
  }
  &:last-child {
    @apply rounded-tr-xl;
  }
}

:deep(tr:hover td) {
  @apply bg-secondary/5;
}
</style>
